import './App.css';
import 'remixicon/fonts/remixicon.css';
import StudentNav from './student-ui/StudentNav';
import StudentMain from './student-ui/StudentMain';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import StudentTaskMain from './student-ui/StudentTaskMain';
import TeacherMain from './teacher-ui/TeacherMain';
import TeacherNav from './teacher-ui/TeacherNav';
import Login from './account/Login';
import Signup from './account/Signup';
import LoggedOut from './account/LoggedOut';
import { useAppSelector } from '../store/Hooks';
import { StudentData } from '../store/viewmodels/StudentViewModel';
import { TeacherData } from '../store/viewmodels/TeacherViewModel';
import Loading from './Loading';


function App() {
    const studentData: StudentData = useAppSelector(state => state.studentData)
    const teacherData: TeacherData = useAppSelector(state => state.teacherData)

    let studentAuth = studentData.isAuthenticated
    let teacherAuth = teacherData.isAuthenticated
    let reloadCheck: boolean = false //If user is a student that reloaded App whilst in mid itemset we need to route them to tasklist and not back to the item they reloaded from.
    let appRoutingLogic: JSX.Element = <></>
    window.location.href.includes('items') ? reloadCheck = true : reloadCheck = false

    if (studentData.loadingState === 'Loading' || teacherData.loadingState === 'Loading') {
        appRoutingLogic = <Loading />
    } else {
        if (studentAuth && reloadCheck) {
            let URL: string = window.location.href.includes('localhost') ? 'http://localhost:3000/student/tasks/' : '/student/tasks/'
            window.location.href = URL
        }
        appRoutingLogic = (studentAuth || teacherAuth) ?
            <Router>
                <div className="max-w-full w-screen min-h-1/2 max-h-screen block bg-white overflow-auto">
                    <Switch>
                        <Route path="/content">
                            <StudentTaskMain />
                        </Route>
                        <Route path="/teacher">
                            {teacherAuth ?
                                <div>
                                    <TeacherNav />
                                    <TeacherMain />
                                </div> :
                                <Redirect to='/student' />}
                        </Route>
                        <Route path="/student">
                            <StudentNav />
                            <StudentMain />
                        </Route>
                        <Route path="/login">
                            <Login />
                        </Route>
                        <Route path="/">
                            {teacherAuth ? <Redirect to='/teacher/' /> : <Redirect to='/student/' />}
                        </Route>
                    </Switch>
                </div>
            </Router >
            :
            <Router>
                <Switch>
                    <Route path='/register'>
                        <Signup />
                    </Route>
                    <Route path='/loggedout'>
                        <LoggedOut />
                    </Route>
                    <Route path='/'>
                        <Redirect to='/login' />
                        <Login />
                    </Route>
                </Switch>
            </Router>
    }
    return (
        <>{appRoutingLogic}</>
    );
}

export default App;